import { ServiceKind } from "@bitory-gmbh/bsm";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { useFeatureAuth } from "../../auth/hooks/use-feature-auth";
import { ServiceKindList } from "@/services/backend/services/types/kinds";

/**
 * useServiceKindList returns the list of GSM service kinds
 * filtered by feature flags and the user's access rights.
 */
export function useServiceKindList(): ServiceKind[] {
  const htzReleased = useBooleanFlagValue("gsm.htz", true);
  const gfsReleased = useBooleanFlagValue("gsm.gfs", true);
  const qpmReleased = useBooleanFlagValue("gsm.qpm", true);
  const rltReleased = useBooleanFlagValue("gsm.rlt", true);
  const vbsReleased = useBooleanFlagValue("gsm.vbs", true);

  const canAccessHTZ = useFeatureAuth("gsm.htz");
  const canAccessGFS = useFeatureAuth("gsm.gfs");
  const canAccessQPM = useFeatureAuth("gsm.qpm");
  const canAccessRLT = useFeatureAuth("gsm.rlt");
  const canAccessVBS = useFeatureAuth("gsm.vbs");

  return ServiceKindList.filter((kind) => {
    switch (kind) {
      case "GFS":
        return gfsReleased && canAccessGFS;
      case "HTZ":
        return htzReleased && canAccessHTZ;
      case "QPM":
        return qpmReleased && canAccessQPM;
      case "RLT":
        return rltReleased && canAccessRLT;
      case "VBS":
        return vbsReleased && canAccessVBS;
      default:
        return false;
    }
  });
}
